import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7ff0c684 = () => interopDefault(import('../src/pages/home/Home.vue' /* webpackChunkName: "" */))
const _c3d61f30 = () => interopDefault(import('../src/pages/EnquiryInfo/EnquiryInfo.vue' /* webpackChunkName: "" */))
const _07c6f538 = () => interopDefault(import('../src/pages/CartManagement/CartManagement.vue' /* webpackChunkName: "" */))
const _1387e804 = () => interopDefault(import('../src/pages/orderDetail/orderDetail.vue' /* webpackChunkName: "" */))
const _0ce35b42 = () => interopDefault(import('../src/pages/businessContactUs/businessContactUs.vue' /* webpackChunkName: "" */))
const _2873e308 = () => interopDefault(import('../src/pages/licence/Licence.vue' /* webpackChunkName: "" */))
const _ba18c140 = () => interopDefault(import('../src/pages/businesscommodity/businesscommodity.vue' /* webpackChunkName: "" */))
const _05e5ee04 = () => interopDefault(import('../src/pages/inquirycenter/inquirycenter.vue' /* webpackChunkName: "" */))
const _27270744 = () => interopDefault(import('../src/pages/ceramics/Ceramics.vue' /* webpackChunkName: "" */))
const _86cbb350 = () => interopDefault(import('../src/pages/ceramics/ceramicslist/CeramicsList.vue' /* webpackChunkName: "" */))
const _05cb6c78 = () => interopDefault(import('../src/pages/ceramics/ceramicsdetail/CeramicsDetail.vue' /* webpackChunkName: "" */))
const _64679ec2 = () => interopDefault(import('../src/pages/news/NewsList.vue' /* webpackChunkName: "" */))
const _572cfc16 = () => interopDefault(import('../src/pages/news/NewsDetail.vue' /* webpackChunkName: "" */))
const _2910d3d8 = () => interopDefault(import('../src/pages/ceramics/fineceramics/FineCeramics.vue' /* webpackChunkName: "" */))
const _72bbad96 = () => interopDefault(import('../src/pages/ceramics/fineceramics/FinePromotionCeramics.vue' /* webpackChunkName: "" */))
const _57c6505e = () => interopDefault(import('../src/pages/ceramics/fineceramics/cart/Cart.vue' /* webpackChunkName: "" */))
const _021ad038 = () => interopDefault(import('../src/pages/search/Search.vue' /* webpackChunkName: "" */))
const _c3a8f678 = () => interopDefault(import('../src/pages/settlement/Settlement.vue' /* webpackChunkName: "" */))
const _7284a336 = () => interopDefault(import('../src/pages/pay/Pay.vue' /* webpackChunkName: "" */))
const _c74ee8a4 = () => interopDefault(import('../src/pages/ceramics/fineceramics/inquiry/Inquiry.vue' /* webpackChunkName: "" */))
const _57681a38 = () => interopDefault(import('../src/pages/login/Login.vue' /* webpackChunkName: "" */))
const _066ac4e4 = () => interopDefault(import('../src/pages/thirdPartyCallback/ThirdPartyCallback.vue' /* webpackChunkName: "" */))
const _2f42e3f8 = () => interopDefault(import('../src/pages/register/Register.vue' /* webpackChunkName: "" */))
const _7b95ab78 = () => interopDefault(import('../src/pages/companyprofile/CompanyProfile.vue' /* webpackChunkName: "" */))
const _7322eb9c = () => interopDefault(import('../src/pages/residence/Residence.vue' /* webpackChunkName: "" */))
const _57bed114 = () => interopDefault(import('../src/pages/privacy/Privacy.vue' /* webpackChunkName: "" */))
const _7159661a = () => interopDefault(import('../src/pages/agreementBusiness/agreementBusiness.vue' /* webpackChunkName: "" */))
const _06ecd070 = () => interopDefault(import('../src/pages/agreementUser/agreementUser.vue' /* webpackChunkName: "" */))
const _11e33b64 = () => interopDefault(import('../src/pages/personalcenter/PersonalCenter.vue' /* webpackChunkName: "" */))

const _78b347ae = () => interopDefault(import('../src/pages/personalcenter/essential/Essential.vue' /* webpackChunkName: "" */))
const _13498dde = () => interopDefault(import('../src/pages/personalcenter/essential/EssentialInit.vue' /* webpackChunkName: "" */))
const _322ad58c = () => interopDefault(import('../src/pages/personalcenter/address/Address.vue' /* webpackChunkName: "" */))
const _093db02e = () => interopDefault(import('../src/pages/personalcenter/order/Order.vue' /* webpackChunkName: "" */))
const _6e0bdef0 = () => interopDefault(import('../src/pages/personalcenter/password/Password.vue' /* webpackChunkName: "" */))
const _db6fe922 = () => interopDefault(import('../src/pages/personalcenter/merchants/index.vue' /* webpackChunkName: "" */))
const _d964115c = () => interopDefault(import('../src/pages/personalcenter/business/index.vue' /* webpackChunkName: "" */))
const _73b797d3 = () => interopDefault(import('../src/pages/personalcenter/thirdAccount/ThirdBindAccount.vue' /* webpackChunkName: "" */))
const _2d197a16 = () => interopDefault(import('../src/pages/personalcenter/address/addaddress/AddAddress.vue' /* webpackChunkName: "" */))
const _45d458a4 = () => interopDefault(import('../src/pages/businesshome/BusinessHome.vue' /* webpackChunkName: "" */))
const _7fad8618 = () => interopDefault(import('../src/pages/businessprofile/BusinessProfile.vue' /* webpackChunkName: "" */))
const _6ebf7464 = () => interopDefault(import('../src/pages/businessfeedback/BusinessFeedback.vue' /* webpackChunkName: "" */))
const _2edf3074 = () => interopDefault(import('../src/pages/businessprofile/RatingsReviews.vue' /* webpackChunkName: "" */))
const _39a79ca8 = () => interopDefault(import('../src/pages/reviseprofile/ReviseProfile.vue' /* webpackChunkName: "" */))
const _4ad74764 = () => interopDefault(import('../src/pages/businessceramics/BusinessCeramics.vue' /* webpackChunkName: "" */))
const _21f7e938 = () => interopDefault(import('../src/pages/businessceramics/businessceramicslist/BusinessCeramicsList.vue' /* webpackChunkName: "" */))
const _3ef4cf30 = () => interopDefault(import('../src/pages/businessaddclassify/BusinessAddClassify.vue' /* webpackChunkName: "" */))
const _46559c78 = () => interopDefault(import('../src/pages/businesspersonal/BusinessPersonal.vue' /* webpackChunkName: "" */))
const _5adb0d59 = () => interopDefault(import('../src/pages/businesspersonal/essential/Essential.vue' /* webpackChunkName: "" */))
const _601204fa = () => interopDefault(import('../src/pages/businesspersonal/essential/merchant/Merchant.vue' /* webpackChunkName: "" */))
const _9ececff8 = () => interopDefault(import('../src/pages/businesspersonal/essential/updatepwd/UpdatePwd.vue' /* webpackChunkName: "" */))
const _bfe2554c = () => interopDefault(import('../src/pages/businesspersonal/essential/operationTable/OperationTable.vue' /* webpackChunkName: "" */))
const _2084708c = () => interopDefault(import('../src/pages/businesspersonal/essential/employee/Employee.vue' /* webpackChunkName: "" */))
const _01722afa = () => interopDefault(import('../src/pages/businesspersonal/essential/addemployee/AddEmployee.vue' /* webpackChunkName: "" */))
const _3072f67a = () => interopDefault(import('../src/pages/businesspersonal/essential/coupon/Coupon.vue' /* webpackChunkName: "" */))
const _ac78ac2c = () => interopDefault(import('../src/pages/businesspersonal/essential/addcoupon/AddCoupon.vue' /* webpackChunkName: "" */))
const _37e7b1fa = () => interopDefault(import('../src/pages/businesspersonal/essential/updatecoupon/UpdateCoupon.vue' /* webpackChunkName: "" */))
const _72dc8f7a = () => interopDefault(import('../src/pages/businesspersonal/essential/updateemployee/UpdateEmployee.vue' /* webpackChunkName: "" */))
const _85615e4e = () => interopDefault(import('../src/pages/businesspersonal/order/Order.vue' /* webpackChunkName: "" */))
const _370bd516 = () => interopDefault(import('../src/pages/businesspersonal/applicationmarket/ApplicationMarket.vue' /* webpackChunkName: "" */))
const _99897fec = () => interopDefault(import('../src/pages/businesspersonal/order/OrderDetail.vue' /* webpackChunkName: "" */))
const _73673089 = () => interopDefault(import('../src/pages/businesspersonal/payment/Payment.vue' /* webpackChunkName: "" */))
const _26fee923 = () => interopDefault(import('../src/pages/businesspersonal/businesspromotion/BusinessPromotion.vue' /* webpackChunkName: "" */))
const _63363feb = () => interopDefault(import('../src/pages/businesspersonal/OtherSystem.vue' /* webpackChunkName: "" */))
const _320eb326 = () => interopDefault(import('../src/pages/businesspersonal/ThirdBindAccount.vue' /* webpackChunkName: "" */))
const _7d325655 = () => interopDefault(import('../src/pages/businesspersonal/record.vue' /* webpackChunkName: "" */))
const _119a5892 = () => interopDefault(import('../src/pages/businesspersonal/payment/openbank/OpenBank.vue' /* webpackChunkName: "" */))
const _fa4cf8b8 = () => interopDefault(import('../src/pages/businesslaunch/BusinessLaunch.vue' /* webpackChunkName: "" */))
const _49340e58 = () => interopDefault(import('../src/pages/businesspersonal/businesspromotion/BusinessPromotionDetail.vue' /* webpackChunkName: "" */))
const _46c4fea4 = () => interopDefault(import('../src/pages/businessmanagement/BusinessManagement.vue' /* webpackChunkName: "" */))
const _1849078a = () => interopDefault(import('../src/pages/businesspersonal/merchanthelp/MerchantHelp.vue' /* webpackChunkName: "" */))
const _1ecd356b = () => interopDefault(import('../src/pages/businesspersonal/quotations.vue' /* webpackChunkName: "" */))
const _104dae4e = () => interopDefault(import('../src/pages/articleList/ArticleList.vue' /* webpackChunkName: "" */))
const _50f8c584 = () => interopDefault(import('../src/pages/announcement/Announcement.vue' /* webpackChunkName: "" */))
const _66716f16 = () => interopDefault(import('../src/pages/announcement/AnnouncementDetail.vue' /* webpackChunkName: "" */))
const _2078f1bf = () => interopDefault(import('../src/pages/articleList/ArticleListDetail.vue' /* webpackChunkName: "" */))
const _99b5e738 = () => interopDefault(import('../src/pages/unbindFacebook/UnbindFacebook.vue' /* webpackChunkName: "" */))
const _00c8055e = () => interopDefault(import('../src/pages/unbindInstagram/UnbindInstagram.vue' /* webpackChunkName: "" */))
const _0b2b53c4 = () => interopDefault(import('../src/pages/help/Help.vue' /* webpackChunkName: "" */))
const _c108d07c = () => interopDefault(import('../src/pages/contactus/ContactUs.vue' /* webpackChunkName: "" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/",
    component: _7ff0c684,
    name: "Home"
  }, {
    path: "/EnquiryInfo",
    component: _c3d61f30,
    name: "EnquiryInfo"
  }, {
    path: "/CartManagement",
    component: _07c6f538,
    name: "CartManagement"
  }, {
    path: "/orderDetail",
    component: _1387e804,
    name: "orderDetail"
  }, {
    path: "/businessContactUs",
    component: _0ce35b42,
    name: "businessContactUs"
  }, {
    path: "/licence",
    component: _2873e308,
    name: "licence"
  }, {
    path: "/businesscommodity",
    component: _ba18c140,
    name: "businesscommodity"
  }, {
    path: "/inquirycenter",
    component: _05e5ee04,
    name: "inquirycenter"
  }, {
    path: "/ceramics",
    component: _27270744,
    name: "Ceramics",
    children: [{
      path: "ceramicslist",
      component: _86cbb350,
      name: "CeramicsList"
    }, {
      path: "ceramicsDetail",
      component: _05cb6c78,
      name: "ceramicsDetail1"
    }]
  }, {
    path: "/newslist",
    component: _64679ec2,
    name: "NewsList"
  }, {
    path: "/newsdetail",
    component: _572cfc16,
    name: "NewsDetail"
  }, {
    path: "/ceramics/fineceramics",
    component: _2910d3d8,
    name: "FineCeramics",
    children: [{
      path: "ceramicsDetail",
      component: _05cb6c78,
      name: "ceramicsDetail"
    }]
  }, {
    path: "/ceramics/finePromotionCeramics",
    component: _72bbad96,
    name: "FinePromotionCeramics"
  }, {
    path: "/cart",
    component: _57c6505e,
    name: "Cart"
  }, {
    path: "/search",
    component: _021ad038,
    name: "Search"
  }, {
    path: "/settlement",
    component: _c3a8f678,
    name: "Settlement"
  }, {
    path: "/pay",
    component: _7284a336,
    name: "Pay"
  }, {
    path: "/inquiry",
    component: _c74ee8a4,
    name: "Inquiry"
  }, {
    path: "/login",
    component: _57681a38,
    name: "Login"
  }, {
    path: "/thirdPartyCallback",
    component: _066ac4e4,
    name: "ThirdPartyCallback"
  }, {
    path: "/register",
    component: _2f42e3f8,
    name: "Register"
  }, {
    path: "/companyprofile",
    component: _7b95ab78,
    name: "CompanyProfile"
  }, {
    path: "/residence",
    component: _7322eb9c,
    name: "Residence"
  }, {
    path: "/privacy",
    component: _57bed114,
    name: "Privacy"
  }, {
    path: "/agreementBusiness",
    component: _7159661a,
    name: "agreementBusiness"
  }, {
    path: "/agreementUser",
    component: _06ecd070,
    name: "agreementUser"
  }, {
    path: "/personalcenter",
    component: _11e33b64,
    children: [{
      path: "",
      redirect: "essential"
    }, {
      path: "essential",
      component: _78b347ae,
      name: "Essential"
    }, {
      path: "essentialInit",
      component: _13498dde,
      name: "EssentialInit"
    }, {
      path: "address",
      component: _322ad58c,
      name: "Address"
    }, {
      path: "order",
      component: _093db02e,
      name: "Order"
    }, {
      path: "password",
      component: _6e0bdef0,
      name: "Password"
    }, {
      path: "merchants",
      component: _db6fe922,
      name: "merchants"
    }, {
      path: "business",
      component: _d964115c,
      name: "business"
    }, {
      path: "thirdAccount",
      component: _73b797d3,
      name: "ThirdAccount"
    }]
  }, {
    path: "/addaddress",
    component: _2d197a16,
    name: "AddAddress"
  }, {
    path: "/businesshome",
    component: _45d458a4,
    name: "BusinessHome"
  }, {
    path: "/businessprofile",
    component: _7fad8618,
    name: "BusinessProfile"
  }, {
    path: "/businessfeedback",
    component: _6ebf7464,
    name: "BusinessFeedback1"
  }, {
    path: "/ratingsreviews",
    component: _2edf3074,
    name: "RatingsReviews"
  }, {
    path: "/businessreviseprofile",
    component: _39a79ca8,
    name: "BusinessReviseProfile"
  }, {
    path: "/businessceramics",
    component: _4ad74764,
    children: [{
      path: "",
      redirect: "businessceramicslist"
    }, {
      path: "businessceramicslist",
      component: _21f7e938,
      name: "BusinessCeramicsList"
    }]
  }, {
    path: "/businessaddclassify",
    component: _3ef4cf30,
    name: "BusinessAddClassify"
  }, {
    path: "/businesspersonal",
    component: _46559c78,
    name: "BusinessPersonal",
    children: [{
      path: "businessessential",
      component: _5adb0d59,
      children: [{
        path: "",
        redirect: "merchant"
      }, {
        path: "merchant",
        component: _601204fa,
        name: "Merchant"
      }, {
        path: "updatepwd",
        component: _9ececff8,
        name: "UpdatePwd"
      }, {
        path: "operationTable",
        component: _bfe2554c,
        name: "OperationTable"
      }, {
        path: "employee",
        component: _2084708c,
        name: "Employee"
      }, {
        path: "addemployee",
        component: _01722afa,
        name: "AddEmployee"
      }, {
        path: "coupon",
        component: _3072f67a,
        name: "Coupon"
      }, {
        path: "addcoupon",
        component: _ac78ac2c,
        name: "AddCoupon"
      }, {
        path: "updatecoupon",
        component: _37e7b1fa,
        name: "UpdateCoupon"
      }, {
        path: "updateemployee",
        component: _72dc8f7a,
        name: "UpdateEmployee"
      }]
    }, {
      path: "businessorder",
      component: _85615e4e,
      name: "BusinessOrder"
    }, {
      path: "applicationmarket",
      component: _370bd516,
      name: "ApplicationMarket"
    }, {
      path: "businessordedetail",
      component: _99897fec,
      name: "BusinessOrderDetail"
    }, {
      path: "businesspayment",
      component: _73673089,
      name: "BusinessPayment"
    }, {
      path: "businessfeedback",
      component: _6ebf7464,
      name: "BusinessFeedback"
    }, {
      path: "businesspromotion",
      component: _26fee923,
      name: "BusinessPromotion"
    }, {
      path: "otherSystem",
      component: _63363feb,
      name: "OtherSystem"
    }, {
      path: "businessThirdBindAccount",
      component: _320eb326,
      name: "BusinessThirdBindAccount"
    }, {
      path: "record",
      component: _7d325655,
      name: "Record"
    }]
  }, {
    path: "/openbank",
    component: _119a5892,
    name: "OpenBank"
  }, {
    path: "/businesslaunch",
    component: _fa4cf8b8,
    name: "BusinessLaunch"
  }, {
    path: "/businesspromotiondetail",
    component: _49340e58,
    name: "BusinessPromotionDetail"
  }, {
    path: "/businessmanagement",
    component: _46c4fea4,
    name: "BusinessManagement"
  }, {
    path: "/merchanthelp",
    component: _1849078a,
    name: "MerchantHelp"
  }, {
    path: "/quotations",
    component: _1ecd356b,
    name: "Quotations"
  }, {
    path: "/articlelist",
    component: _104dae4e,
    name: "ArticleList"
  }, {
    path: "/announcement",
    component: _50f8c584,
    name: "Announcement"
  }, {
    path: "/announcementdetail",
    component: _66716f16,
    name: "AnnouncementDetail"
  }, {
    path: "/articlelistdetail",
    component: _2078f1bf,
    name: "ArticleListDetail"
  }, {
    path: "/unbindFacebook",
    component: _99b5e738,
    name: "UnbindFacebook"
  }, {
    path: "/unbindInstagram",
    component: _00c8055e,
    name: "UnbindInstagram"
  }, {
    path: "/help",
    component: _0b2b53c4,
    name: "Help"
  }, {
    path: "/contactus",
    component: _c108d07c,
    name: "ContactUs"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
